import { render, staticRenderFns } from "./AppContactsFilter.vue?vue&type=template&id=72afb5de"
import script from "./AppContactsFilter.vue?vue&type=script&lang=js"
export * from "./AppContactsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports